import { render, staticRenderFns } from "./avggraph.vue?vue&type=template&id=65736716&scoped=true&"
import script from "./avggraph.vue?vue&type=script&lang=js&"
export * from "./avggraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65736716",
  null
  
)

export default component.exports